/**
 * @pageName BlogPosts
 * @slotType dashboard plugin
 */
export type PostsBannerParams = EmptyParams;

/** @internal */
export type EmptyParams = {};

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type PublishedPostItemMoreActionsMenuParams = ActionParams;

// These are used in the dev center, do not delete them
/** @internal */
export type ActionParams = {
  // ID of the selected item.
  selectedId: string;
};

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type PublishedPostItemsBulkMoreActionsMenuParams = BulkActionParams;

/** @internal */
export type BulkActionParams = {
  // ID of the selected items.
  selectedIds: string[];
};

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type DraftPostItemMoreActionsMenuParams = ActionParams;

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type DraftPostItemsBulkMoreActionsMenuParams = BulkActionParams;

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type ScheduledPostItemMoreActionsMenuParams = ActionParams;

/**
 * @pageName BlogPosts
 * @slotType dashboard menu plugin
 */
export type ScheduledItemsBulkMoreActionsMenuParams = BulkActionParams;
